import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=b2a8a790&scoped=true&"
import script from "./splash.vue?vue&type=script&lang=js&"
export * from "./splash.vue?vue&type=script&lang=js&"
import style0 from "./splash.vue?vue&type=style&index=0&id=b2a8a790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a8a790",
  null
  
)

component.options.__file = "splash.vue"
export default component.exports